export default __webpack_public_path__ + "static/media/png-white.3cf0748f.svg";